import apiClient from '../shared/api/client';

export async function listLabels(kind) {
  const qs = kind ? `?kind=${encodeURIComponent(kind)}` : '';
  const res = await apiClient(`/api/labels${qs}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to load labels');
  }
  return res.json();
}

export async function createLabel({ name, color = 'neutral', kind = 'both', description = null }) {
  const res = await apiClient(`/api/labels`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, color, kind, description })
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to create label');
  }
  return res.json();
}

export async function updateLabel(id, patch) {
  const res = await apiClient(`/api/labels/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to update label');
  }
  return res.json();
}

export async function deleteLabel(id) {
  const res = await apiClient(`/api/labels/${id}`, { method: 'DELETE' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to delete label');
  }
  return true;
}

export async function setFamilyLabels(familyId, labelIds) {
  const res = await apiClient(`/api/families/${familyId}/labels`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label_ids: labelIds })
  });
  if (!res.ok) throw new Error('Failed to set family labels');
  return res.json();
}

export async function setStudentLabels(studentId, labelIds) {
  const res = await apiClient(`/api/students/${studentId}/labels`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label_ids: labelIds })
  });
  if (!res.ok) throw new Error('Failed to set student labels');
  return res.json();
}
